import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
	Box,
	Collapse,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useState } from "react";
import {
	HeatEventSummary,
	ProductionEventSummary,
} from "../../models/SalesOverview";
import { headerCellStyle } from "../utils";
import { SectionRow } from "./SectionRow";

type Props = {
	events: ProductionEventSummary[];
	heatsByEvent: HeatEventSummary[];
};

export const HeatsBySection = ({ events, heatsByEvent }: Props) => {
	const [open, setOpen] = useState(false);

	const sectionEvents = events
		.filter((e) => e.SectionId != null)
		.slice()
		.sort((a, b) => a.EventStart.getTime() - b.EventStart.getTime());

	const heatsByEventId = new Map<number, HeatEventSummary[]>();
	for (const h of heatsByEvent) {
		const list = heatsByEventId.get(h.EventId) ?? [];
		list.push(h);
		heatsByEventId.set(h.EventId, list);
	}

	const totalHeats = heatsByEvent.length;

	return (
		<Box>
			<Box
				onClick={() => setOpen((v) => !v)}
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					cursor: "pointer",
					py: 0.5,
					userSelect: "none",
					"&:hover": { backgroundColor: "#fafafa" },
				}}
			>
				<Typography variant="caption" sx={{ fontWeight: 600, color: "#555" }}>
					Sections & Heats
					<Typography
						component="span"
						variant="caption"
						sx={{ color: "#999", ml: 0.75 }}
					>
						({sectionEvents.length} events · {totalHeats} heats)
					</Typography>
				</Typography>
				<IconButton size="small" sx={{ p: 0.25 }}>
					<ExpandMoreIcon
						fontSize="small"
						sx={{
							transform: open ? "rotate(180deg)" : "rotate(0deg)",
							transition: "transform 0.2s",
						}}
					/>
				</IconButton>
			</Box>

			<Collapse in={open} timeout="auto" unmountOnExit>
				<Box sx={{ pt: 0.5 }}>
					{sectionEvents.length === 0 ? (
						<Typography
							sx={{
								fontSize: "0.72rem",
								color: "#999",
								fontStyle: "italic",
							}}
						>
							No section events this month
						</Typography>
					) : (
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell sx={{ ...headerCellStyle, width: 28 }} />
									<TableCell sx={headerCellStyle}>Section</TableCell>
									<TableCell sx={headerCellStyle} align="right">
										Start
									</TableCell>
									<TableCell sx={headerCellStyle} align="right">
										End
									</TableCell>
									<TableCell sx={headerCellStyle} align="right">
										Scheduled Tons
									</TableCell>
									<TableCell sx={headerCellStyle} align="right">
										TPH
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{sectionEvents.map((e) => (
									<SectionRow
										key={e.EventId}
										event={e}
										heats={heatsByEventId.get(e.EventId) ?? []}
									/>
								))}
							</TableBody>
						</Table>
					)}
				</Box>
			</Collapse>
		</Box>
	);
};
